import { gql } from '@apollo/client'
import { CHATBOT_CONVERSATION_FIELDS } from './fragments/chatbot_conversation'

export const CHATBOT_CONVERSATION = gql`
  ${CHATBOT_CONVERSATION_FIELDS}
  query chatbotConversation($id: ID, $providerId: ID) {
    chatbotConversation(id: $id, providerId: $providerId) {
      ...ChatbotConversationFields
    }
  }
`
